import React from 'react';
import { LandingTopWidget } from '../../organisms/landing';
import { SettingsWrapper } from '../../organisms/settings/SettingsWrapper';
import { SettingsAccessControl } from '../../organisms/settings/SettingsAccessControl';
import { ModelConfigurationMain } from '../../organisms/settings/modelConfiguration/ModelConfigurationMain';

/**
 * presentations/components/pages/settings/ModelConfigurationPage.tsx
 */
const ModelConfigurationPage: React.FC = () => (
  <SettingsAccessControl allowedRoles='systemAdmin'>
    <div className='h-full flex flex-col bg-white'>
      <LandingTopWidget title='Settings' hideSearchBar hideUploadButton />

      <SettingsWrapper>
        <ModelConfigurationMain />
      </SettingsWrapper>
    </div>
  </SettingsAccessControl>
);

export default ModelConfigurationPage;
